import React, {useState} from "react";
import {GamePageState} from "../../../common/utils/pageState";
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import {GameInfoComponent} from "../../../common/components/game-info/GameInfoComponent";
import {INTERESTING_DISCUSSION_GAME as GAME} from "../../../common/utils/games";
import InterestingDiscussionGameConfig from "./components/InterestingDiscussionGameConfig";
import InterestingStoryGamePlay from "./components/InterestingDiscussionGamePlay";
import {IGameDescription, IInterestingDiscussionGameConfig, Localised} from "../../../common/types";
import { usePageTitle } from "../../../common/hooks";
import {getCurrentLang} from "../../../common/utils/lang";

const INITIAL_GAME_CONFIG: IInterestingDiscussionGameConfig = {
    randomTopic: true,
    customTopic: "",
    selectedPlayerIds: [],
    selectedCharactersGroupIndexes: [0]
};

const gameDescription:Localised<IGameDescription> = require("./description.json");

const InterestingDiscussionGamePage = () => {
    usePageTitle("games.interesting-discussion.name");

    const [page, setPage] = useState<GamePageState>(GamePageState.INFO);
    const [config, changeConfig] = useState<IInterestingDiscussionGameConfig>(INITIAL_GAME_CONFIG);

    const pageChangeClick = (targetState: GamePageState) => () => {
        setPage(targetState);
    };

    const activeLang = getCurrentLang();
    const infoPage = <GameInfoComponent game={GAME} description={gameDescription[activeLang]} nextClick={pageChangeClick(GamePageState.CONFIG)}/>;

    const configPage = <InterestingDiscussionGameConfig
        nextToPlay={pageChangeClick(GamePageState.PLAY)}
        backToDetails={pageChangeClick(GamePageState.INFO)}
        config={config}
        changeConfig={changeConfig} />;

    const playPage = <InterestingStoryGamePlay
        backToDetails={pageChangeClick(GamePageState.INFO)}
        backToConfig={pageChangeClick(GamePageState.CONFIG)}
        config={config}
    />;

    const displayedPage = page === GamePageState.INFO ? infoPage : (page === GamePageState.CONFIG ? configPage : playPage);

    return  (
        <PageContainer fixedHeaderFooter={true}>
            {displayedPage}
        </PageContainer>
    );
};

export default InterestingDiscussionGamePage;
